import { CatalogManagerRole } from "./models/catalog_manager_role";
import { User } from "./models/user";

interface Environment {
    organization_id: number;
    session_key: string;
    sentry_dsn?: string;
    environment?: string;
    timezone: string;
    language_overrides: any;

    current_user: User;

    params
    csrf_token
    base_path
    canvas_url
    post_message_token: string;
    brand_variables: any;
    launch_params
    regexps?: { [key: string]: RegExp }
    catalog_manager_roles: CatalogManagerRole[];

    [key: string]: any;
}

export const csrfToken = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement).content;
export const env: Environment = JSON.parse((document.querySelector('meta[name="js-env"]') as HTMLMetaElement).content);

if (env.regexps) {
    const regexes = {}
    for (let [k, str] of Object.entries(env.regexps)) {
        regexes[k] = new RegExp(str)
    }
    env.regexps = regexes;
}

if (env.environment == 'development') {
    window['ENV'] = env;
    console.log(env);
}

if (env.catalog_manager_roles?.length > 0) {
    env.catalog_manager_roles = env.catalog_manager_roles.map(role => new CatalogManagerRole(role))
}
